import HttpClienteToken from '../../services/HttpClientToken';

import { TipoCalificacionProps } from '../../interfaces/catalogos/TipoCalificacionInterface';

export const TipoCalificaciones = () => {

    return new Promise<TipoCalificacionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoCalificacion/', token)
            .then( ({ data } : { data : TipoCalificacionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoCalificaciones = () => {

    return new Promise<TipoCalificacionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoCalificacion/ObtenerTipoCalificaciones', token)
            .then( ({ data } : { data : TipoCalificacionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoCalificacion = ( params: TipoCalificacionProps ) => {

    return new Promise<TipoCalificacionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoCalificacion/Actualizar', params, token)
            .then( ({ data } : { data : TipoCalificacionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoCalificacion: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoCalificacion = ( params: TipoCalificacionProps ) => {

    return new Promise<TipoCalificacionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoCalificacion/Agregar', params, token)
            .then( ({ data } : { data : TipoCalificacionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoCalificacion: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}